import { obj_type, tuple_type, bool_type, int32_type, lambda_type, unit_type, option_type, string_type, union_type, record_type, array_type, float64_type, int16_type, class_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { mkImageLoader as mkImageLoader_1 } from "../../../src/RAWMap.Client/Visualization/js/ImageLoader.js";
import { Union, Record } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { Bounds_$reflection, Meshes_FieldDataArrayNames_$reflection, InteractionMode_$reflection, DisplayMap_$reflection } from "./Common/CommonBindings.js";
import { StentMeasurement_$reflection } from "./CenterlineMeasurement/StentPlanning/SharedTypes.js";
import { ofArray } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { Visualization_UnifiedDistanceBranch_$reflection, Visualization_UnifiedTransitionBranch_$reflection } from "../RAWMap.Models/Common.js";
import { ScreenshotProps_$reflection } from "./Screenshot/ScreenshotBindings.js";
import { SliceValues_$reflection, SlicePlaneProps_$reflection } from "./SlicePlane/SlicePlaneBindings.js";
import { NotesProps_$reflection } from "./Notes/NotesBindings.js";
import { CameraProps_$reflection } from "./Camera/CameraBindings.js";
import { CenterlineMeasurementProps_$reflection } from "./CenterlineMeasurement/CenterlineMeasurementBindings.js";
import { CalipersProps_$reflection } from "./Calipers/CalipersBindings.js";
import { AnatomyOrientationProps_$reflection } from "./AnatomyOrientation/AnatomyOrientationBindings.js";
import { PickedMapValueProps_$reflection } from "./PickedMapValue/PickedMapValueBindings.js";
import { DicomViewMode_$reflection, ViewportLocation_$reflection } from "./Common/CommonTypes.js";
import { StentPlanningCenterlinesProps_$reflection } from "./StentPlanningCenterlines/StentPlanningCenterlinesBindings.js";
import { Bindings_IndexBounds_$reflection } from "../RAWMap.Models/View/CenterlineMeasurement.js";

export class ImageLoader {
    constructor() {
    }
}

export function ImageLoader_$reflection() {
    return class_type("Client.Visualization.Bindings.ImageLoader", undefined, ImageLoader);
}

export const mkImageLoader = mkImageLoader_1;

export class SegmentationSliceData extends Record {
    constructor(buffer, dimensions, origin, spacing) {
        super();
        this.buffer = buffer;
        this.dimensions = dimensions;
        this.origin = origin;
        this.spacing = spacing;
    }
}

export function SegmentationSliceData_$reflection() {
    return record_type("Client.Visualization.Bindings.SegmentationSliceData", [], SegmentationSliceData, () => [["buffer", class_type("Fable.Core.JS.TypedArray`1", [int16_type])], ["dimensions", array_type(float64_type)], ["origin", array_type(float64_type)], ["spacing", array_type(float64_type)]]);
}

export class Viewport extends Record {
    constructor(map, planeAdjustment) {
        super();
        this.map = map;
        this.planeAdjustment = planeAdjustment;
    }
}

export function Viewport_$reflection() {
    return record_type("Client.Visualization.Bindings.Viewport", [], Viewport, () => [["map", DisplayMap_$reflection()], ["planeAdjustment", array_type(float64_type)]]);
}

export class InteractionView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SingleView", "CompareView", "StandardView", "HiddenView"];
    }
}

export function InteractionView_$reflection() {
    return union_type("Client.Visualization.Bindings.InteractionView", [], InteractionView, () => [[], [], [], []]);
}

export class InteractionModeProps extends Record {
    constructor(interactionMode, interactionView) {
        super();
        this.interactionMode = interactionMode;
        this.interactionView = interactionView;
    }
}

export function InteractionModeProps_$reflection() {
    return record_type("Client.Visualization.Bindings.InteractionModeProps", [], InteractionModeProps, () => [["interactionMode", InteractionMode_$reflection()], ["interactionView", InteractionView_$reflection()]]);
}

export class StentPlanningEventNames extends Record {
    constructor(CaptureStentPlanScreenshots, CaptureStentPlanZoomedInScreenshot) {
        super();
        this.CaptureStentPlanScreenshots = CaptureStentPlanScreenshots;
        this.CaptureStentPlanZoomedInScreenshot = CaptureStentPlanZoomedInScreenshot;
    }
}

export function StentPlanningEventNames_$reflection() {
    return record_type("Client.Visualization.Bindings.StentPlanningEventNames", [], StentPlanningEventNames, () => [["CaptureStentPlanScreenshots", string_type], ["CaptureStentPlanZoomedInScreenshot", string_type]]);
}

export const stentPlanningEventNames = new StentPlanningEventNames("capture_stent_plan_screenshots", "capture_stent_plan_zoomed_in_screenshot");

export class StentPlanningProps extends Record {
    constructor(fieldDataArrayNames, currentMeasurements, maybeActiveMeasurement, onMeasurementLabelClicked, eventNames) {
        super();
        this.fieldDataArrayNames = fieldDataArrayNames;
        this.currentMeasurements = currentMeasurements;
        this.maybeActiveMeasurement = maybeActiveMeasurement;
        this.onMeasurementLabelClicked = onMeasurementLabelClicked;
        this.eventNames = eventNames;
    }
}

export function StentPlanningProps_$reflection() {
    return record_type("Client.Visualization.Bindings.StentPlanningProps", [], StentPlanningProps, () => [["fieldDataArrayNames", Meshes_FieldDataArrayNames_$reflection()], ["currentMeasurements", array_type(StentMeasurement_$reflection())], ["maybeActiveMeasurement", option_type(StentMeasurement_$reflection())], ["onMeasurementLabelClicked", lambda_type(string_type, unit_type)], ["eventNames", StentPlanningEventNames_$reflection()]]);
}

export class RotationAngles extends Record {
    constructor(azimuth, elevation) {
        super();
        this.azimuth = azimuth;
        this.elevation = elevation;
    }
}

export function RotationAngles_$reflection() {
    return record_type("Client.Visualization.Bindings.RotationAngles", [], RotationAngles, () => [["azimuth", float64_type], ["elevation", float64_type]]);
}

export class CompositeScreenshotType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Renal", "Trunk", "LeftIliac", "RightIliac"];
    }
}

export function CompositeScreenshotType_$reflection() {
    return union_type("Client.Visualization.Bindings.CompositeScreenshotType", [], CompositeScreenshotType, () => [[], [], [], []]);
}

export function CompositeScreenshotType_get_all() {
    return ofArray([new CompositeScreenshotType(0, []), new CompositeScreenshotType(1, []), new CompositeScreenshotType(2, []), new CompositeScreenshotType(3, [])]);
}

export class CaptureStentPlanZoomedInScreenshotEventArgs extends Record {
    constructor(focalPointIndex, focalPointBranch, angles, visibleLabelGroupNames, callback, zoomFactor, pitch, screenshotType) {
        super();
        this.focalPointIndex = (focalPointIndex | 0);
        this.focalPointBranch = focalPointBranch;
        this.angles = angles;
        this.visibleLabelGroupNames = visibleLabelGroupNames;
        this.callback = callback;
        this.zoomFactor = zoomFactor;
        this.pitch = pitch;
        this.screenshotType = screenshotType;
    }
}

export function CaptureStentPlanZoomedInScreenshotEventArgs_$reflection() {
    return record_type("Client.Visualization.Bindings.CaptureStentPlanZoomedInScreenshotEventArgs", [], CaptureStentPlanZoomedInScreenshotEventArgs, () => [["focalPointIndex", int32_type], ["focalPointBranch", Visualization_UnifiedTransitionBranch_$reflection()], ["angles", RotationAngles_$reflection()], ["visibleLabelGroupNames", array_type(string_type)], ["callback", lambda_type(string_type, unit_type)], ["zoomFactor", float64_type], ["pitch", float64_type], ["screenshotType", CompositeScreenshotType_$reflection()]]);
}

export class SlicingMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Axial", "Coronal", "Sagittal"];
    }
}

export function SlicingMode_$reflection() {
    return union_type("Client.Visualization.Bindings.SlicingMode", [], SlicingMode, () => [[], [], []]);
}

export class LengthMeasurementState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Idle", "Adding", "Removing"];
    }
}

export function LengthMeasurementState_$reflection() {
    return union_type("Client.Visualization.Bindings.LengthMeasurementState", [], LengthMeasurementState, () => [[], [], []]);
}

export class AngleMeasurementState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Idle", "Adding", "Removing"];
    }
}

export function AngleMeasurementState_$reflection() {
    return union_type("Client.Visualization.Bindings.AngleMeasurementState", [], AngleMeasurementState, () => [[], [], []]);
}

export class Widget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DistanceWidget", "SegmentationWidget", "CrosshairWidget", "AngleWidget"];
    }
}

export function Widget_$reflection() {
    return union_type("Client.Visualization.Bindings.Widget", [], Widget, () => [[], [], [], []]);
}

export class EventNames extends Record {
    constructor(FullyResetCamera, SetAngle, IncrementAngle, SetFocalPointByIndex, CaptureCustomScreenshot) {
        super();
        this.FullyResetCamera = FullyResetCamera;
        this.SetAngle = SetAngle;
        this.IncrementAngle = IncrementAngle;
        this.SetFocalPointByIndex = SetFocalPointByIndex;
        this.CaptureCustomScreenshot = CaptureCustomScreenshot;
    }
}

export function EventNames_$reflection() {
    return record_type("Client.Visualization.Bindings.EventNames", [], EventNames, () => [["FullyResetCamera", string_type], ["SetAngle", string_type], ["IncrementAngle", string_type], ["SetFocalPointByIndex", string_type], ["CaptureCustomScreenshot", string_type]]);
}

export const eventNames = new EventNames("fully_reset_camera", "set_angle", "increment_angle", "set_focal_point_by_index", "capture_custom_screenshot_mesh");

export class CprEventNames extends Record {
    constructor(ConfirmChanges, CancelChanges, ExportVtp, ImportVtp, ExportStretchedCprControlPoints, ImportStretchedCprControlPoints, CaptureCprVisualizationScreenshot, CaptureCustomScreenshot) {
        super();
        this.ConfirmChanges = ConfirmChanges;
        this.CancelChanges = CancelChanges;
        this.ExportVtp = ExportVtp;
        this.ImportVtp = ImportVtp;
        this.ExportStretchedCprControlPoints = ExportStretchedCprControlPoints;
        this.ImportStretchedCprControlPoints = ImportStretchedCprControlPoints;
        this.CaptureCprVisualizationScreenshot = CaptureCprVisualizationScreenshot;
        this.CaptureCustomScreenshot = CaptureCustomScreenshot;
    }
}

export function CprEventNames_$reflection() {
    return record_type("Client.Visualization.Bindings.CprEventNames", [], CprEventNames, () => [["ConfirmChanges", string_type], ["CancelChanges", string_type], ["ExportVtp", string_type], ["ImportVtp", string_type], ["ExportStretchedCprControlPoints", string_type], ["ImportStretchedCprControlPoints", string_type], ["CaptureCprVisualizationScreenshot", string_type], ["CaptureCustomScreenshot", string_type]]);
}

export const cprEventNames = new CprEventNames("confirm_changes", "cancel_changes", "export_vtp", "import_vtp", "export_stretched_cpr_control_points", "import_stretched_cpr_control_points", "capture_cpr_visualization_screenshot", "capture_custom_screenshot_cpr");

export class CprViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Stretched", "Straightened"];
    }
}

export function CprViewMode_$reflection() {
    return union_type("Client.Visualization.Bindings.CprViewMode", [], CprViewMode, () => [[], []]);
}

export class CprControlPointMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Edit", "AddOrDelete"];
    }
}

export function CprControlPointMode_$reflection() {
    return union_type("Client.Visualization.Bindings.CprControlPointMode", [], CprControlPointMode, () => [[], []]);
}

export function CprControlPointModeModule_invert(_arg) {
    if (_arg.tag === 1) {
        return new CprControlPointMode(0, []);
    }
    else {
        return new CprControlPointMode(1, []);
    }
}

export class VisualizationProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ScreenshotProps", "InteractionModeProps"];
    }
}

export function VisualizationProps_$reflection() {
    return union_type("Client.Visualization.Bindings.VisualizationProps", [], VisualizationProps, () => [[["Item", ScreenshotProps_$reflection()]], [["Item", InteractionModeProps_$reflection()]]]);
}

export class MeshVisualizationProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ViewportId", "CurrentStudyMeshes", "PreviousStudyMeshes", "SlicePlaneProps", "SelectedMap", "ShowCenterline", "OverlayPreviousStudyMaps", "OnViewportResized", "StaticNotesProps", "MeasurementNotesProps", "CameraProps", "CenterlineMeasurementProps", "CalipersProps", "AnatomyOrientationProps", "ShowPreviousStudyMapsOnly", "PickedMapValueProps", "MeshViewportLocation", "IsSliceScroll", "OnMeshSliceChange", "IsStentPlanning", "ShowStentPlanningCenterlines", "StentPlanningCenterlinesProps", "StentPlanningProps", "IsVisible", "OnRotationChange", "EventNames", "SelectedDicomView", "OnVisualizationReady", "RawThreshold", "OnRawThresholdChange"];
    }
}

export function MeshVisualizationProps_$reflection() {
    return union_type("Client.Visualization.Bindings.MeshVisualizationProps", [], MeshVisualizationProps, () => [[["Item", string_type]], [["Item", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))]], [["Item", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))]], [["Item", array_type(SlicePlaneProps_$reflection())]], [["Item", DisplayMap_$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", lambda_type(Bounds_$reflection(), unit_type)]], [["Item", NotesProps_$reflection()]], [["Item", NotesProps_$reflection()]], [["Item", CameraProps_$reflection()]], [["Item", CenterlineMeasurementProps_$reflection()]], [["Item", CalipersProps_$reflection()]], [["Item", AnatomyOrientationProps_$reflection()]], [["Item", bool_type]], [["Item", PickedMapValueProps_$reflection()]], [["Item", ViewportLocation_$reflection()]], [["Item", bool_type]], [["Item", lambda_type(float64_type, unit_type)]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(StentPlanningCenterlinesProps_$reflection())]], [["Item", StentPlanningProps_$reflection()]], [["Item", bool_type]], [["Item", lambda_type(RotationAngles_$reflection(), unit_type)]], [["Item", EventNames_$reflection()]], [["Item", DicomViewMode_$reflection()]], [["Item", lambda_type(tuple_type(string_type, bool_type), unit_type)]], [["Item", float64_type]], [["Item", lambda_type(float64_type, unit_type)]]]);
}

export class SegmentationColor extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Red", "Blue"];
    }
}

export function SegmentationColor_$reflection() {
    return union_type("Client.Visualization.Bindings.SegmentationColor", [], SegmentationColor, () => [[], []]);
}

export class SegmentationPaintingMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Bump", "Paint", "Erase"];
    }
}

export function SegmentationPaintingMode_$reflection() {
    return union_type("Client.Visualization.Bindings.SegmentationPaintingMode", [], SegmentationPaintingMode, () => [[], [], []]);
}

export class SegmentationPropsModel extends Record {
    constructor(paintingEnabled, paintingMode, paintingBrushSize, segmentationOpacity, segmentationBorderOpacity, segmentationBorderThickness) {
        super();
        this.paintingEnabled = paintingEnabled;
        this.paintingMode = paintingMode;
        this.paintingBrushSize = (paintingBrushSize | 0);
        this.segmentationOpacity = segmentationOpacity;
        this.segmentationBorderOpacity = segmentationBorderOpacity;
        this.segmentationBorderThickness = (segmentationBorderThickness | 0);
    }
}

export function SegmentationPropsModel_$reflection() {
    return record_type("Client.Visualization.Bindings.SegmentationPropsModel", [], SegmentationPropsModel, () => [["paintingEnabled", bool_type], ["paintingMode", SegmentationPaintingMode_$reflection()], ["paintingBrushSize", int32_type], ["segmentationOpacity", float64_type], ["segmentationBorderOpacity", float64_type], ["segmentationBorderThickness", int32_type]]);
}

export class LengthPropsModel extends Record {
    constructor(measurementIds, lengthMeasurementState, addedMeasurementCallback, removedMeasurementCallback) {
        super();
        this.measurementIds = measurementIds;
        this.lengthMeasurementState = lengthMeasurementState;
        this.addedMeasurementCallback = addedMeasurementCallback;
        this.removedMeasurementCallback = removedMeasurementCallback;
    }
}

export function LengthPropsModel_$reflection() {
    return record_type("Client.Visualization.Bindings.LengthPropsModel", [], LengthPropsModel, () => [["measurementIds", array_type(class_type("System.Guid"))], ["lengthMeasurementState", LengthMeasurementState_$reflection()], ["addedMeasurementCallback", lambda_type(unit_type, unit_type)], ["removedMeasurementCallback", lambda_type(class_type("System.Guid"), unit_type)]]);
}

export class AnglePropsModel extends Record {
    constructor(measurementIds, angleMeasurementState, addedMeasurementCallback, removedMeasurementCallback) {
        super();
        this.measurementIds = measurementIds;
        this.angleMeasurementState = angleMeasurementState;
        this.addedMeasurementCallback = addedMeasurementCallback;
        this.removedMeasurementCallback = removedMeasurementCallback;
    }
}

export function AnglePropsModel_$reflection() {
    return record_type("Client.Visualization.Bindings.AnglePropsModel", [], AnglePropsModel, () => [["measurementIds", array_type(class_type("System.Guid"))], ["angleMeasurementState", AngleMeasurementState_$reflection()], ["addedMeasurementCallback", lambda_type(unit_type, unit_type)], ["removedMeasurementCallback", lambda_type(class_type("System.Guid"), unit_type)]]);
}

export class DicomEventNames extends Record {
    constructor(CaptureDicomVisualizationScreenshot, CaptureCustomScreenshot) {
        super();
        this.CaptureDicomVisualizationScreenshot = CaptureDicomVisualizationScreenshot;
        this.CaptureCustomScreenshot = CaptureCustomScreenshot;
    }
}

export function DicomEventNames_$reflection() {
    return record_type("Client.Visualization.Bindings.DicomEventNames", [], DicomEventNames, () => [["CaptureDicomVisualizationScreenshot", string_type], ["CaptureCustomScreenshot", string_type]]);
}

export const dicomEventNames = new DicomEventNames("capture_dicom_visualization_screenshot", "capture_custom_screenshot_dicom");

export class CanvasInfo extends Record {
    constructor(viewportId, canvasData) {
        super();
        this.viewportId = viewportId;
        this.canvasData = canvasData;
    }
}

export function CanvasInfo_$reflection() {
    return record_type("Client.Visualization.Bindings.CanvasInfo", [], CanvasInfo, () => [["viewportId", string_type], ["canvasData", string_type]]);
}

export class CustomScreenshotEventArgs extends Record {
    constructor(callback, viewportId) {
        super();
        this.callback = callback;
        this.viewportId = viewportId;
    }
}

export function CustomScreenshotEventArgs_$reflection() {
    return record_type("Client.Visualization.Bindings.CustomScreenshotEventArgs", [], CustomScreenshotEventArgs, () => [["callback", lambda_type(CanvasInfo_$reflection(), unit_type)], ["viewportId", string_type]]);
}

export class CprVisualizationProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ViewportId", "CprViewMode", "SelectedBranch", "ImageFiles", "OnTouchStart", "OnTouchEnd", "IsSliceScroll", "AngleInDegrees", "OnAngleChanged", "IsVisible", "WallCenterline", "OnCenterlinePointEdit", "EventNames", "CprControlPointMode", "ImageLoader", "OnCenterlineVtpExported", "MaybeActiveMeasurement", "OnStretchedCprControlPointsExported", "OnReady", "OnVisualizationReady"];
    }
}

export function CprVisualizationProps_$reflection() {
    return union_type("Client.Visualization.Bindings.CprVisualizationProps", [], CprVisualizationProps, () => [[["Item", string_type]], [["Item", CprViewMode_$reflection()]], [["Item", Visualization_UnifiedDistanceBranch_$reflection()]], [["Item", array_type(class_type("Browser.Types.File", undefined))]], [["Item", lambda_type(class_type("Browser.Types.TouchEvent", undefined), unit_type)]], [["Item", lambda_type(class_type("Browser.Types.TouchEvent", undefined), unit_type)]], [["Item", bool_type]], [["Item", int32_type]], [["Item", lambda_type(float64_type, unit_type)]], [["Item", bool_type]], [["Item", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IVtkDataSet"))]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", CprEventNames_$reflection()]], [["Item", CprControlPointMode_$reflection()]], [["Item", ImageLoader_$reflection()]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", option_type(StentMeasurement_$reflection())]], [["Item", lambda_type(obj_type, unit_type)]], [["Item", lambda_type(unit_type, unit_type)]], [["Item", lambda_type(tuple_type(string_type, bool_type), unit_type)]]]);
}

export class ViewportBounds extends Record {
    constructor(viewportId, bounds) {
        super();
        this.viewportId = viewportId;
        this.bounds = bounds;
    }
}

export function ViewportBounds_$reflection() {
    return record_type("Client.Visualization.Bindings.ViewportBounds", [], ViewportBounds, () => [["viewportId", string_type], ["bounds", Bindings_IndexBounds_$reflection()]]);
}

export class DicomVisualizationProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ViewportId", "ImageFiles", "MaskFiles", "SegmentationMaskType", "ShowMasks", "OnSliceChange", "OnCenterlineSliceScroll", "OnTouchStart", "OnTouchEnd", "IsSliceScroll", "SlicePlaneIndex", "IsCenterline", "SegmentationProps", "SegmentationColor", "LengthProps", "AngleProps", "IsVisible", "SlicingMode", "ActiveWidget", "ActiveMeasurement", "CrosshairsWidgetFactory", "CenterlineSegmentationChangedCallback", "AxialSegmentationChangedCallback", "EventNames", "ImageLoader", "OnBoundsAcquired", "ModifiedSegmentations", "OnVisualizationReady"];
    }
}

export function DicomVisualizationProps_$reflection() {
    return union_type("Client.Visualization.Bindings.DicomVisualizationProps", [], DicomVisualizationProps, () => [[["Item", string_type]], [["Item", array_type(class_type("Browser.Types.File", undefined))]], [["Item", array_type(class_type("Browser.Types.File", undefined))]], [["Item", string_type]], [["Item", bool_type]], [["Item", lambda_type(SliceValues_$reflection(), unit_type)]], [["Item", option_type(lambda_type(float64_type, unit_type))]], [["Item", lambda_type(class_type("Browser.Types.TouchEvent", undefined), unit_type)]], [["Item", lambda_type(class_type("Browser.Types.TouchEvent", undefined), unit_type)]], [["Item", bool_type]], [["Item", option_type(float64_type)]], [["Item", bool_type]], [["Item", SegmentationPropsModel_$reflection()]], [["Item", SegmentationColor_$reflection()]], [["Item", LengthPropsModel_$reflection()]], [["Item", AnglePropsModel_$reflection()]], [["Item", bool_type]], [["Item", SlicingMode_$reflection()]], [["Item", option_type(Widget_$reflection())]], [["Item", option_type(StentMeasurement_$reflection())]], [["Item", obj_type]], [["Item", lambda_type(int32_type, lambda_type(SegmentationSliceData_$reflection(), unit_type))]], [["Item", lambda_type(int32_type, lambda_type(SegmentationSliceData_$reflection(), unit_type))]], [["Item", DicomEventNames_$reflection()]], [["Item", ImageLoader_$reflection()]], [["Item", lambda_type(ViewportBounds_$reflection(), unit_type)]], [["Item", array_type(tuple_type(int32_type, SegmentationSliceData_$reflection()))]], [["Item", lambda_type(tuple_type(string_type, bool_type), unit_type)]]]);
}

